module.exports = __webpack_public_path__ + "img/barber-1.c3843f3d.svg";